<template>
    <div>
        <data-table
            :table-data="tableData"
            :columns="tableColumns"
            :is-pagination-show="false"
            @removeItem="removeItem"
        />
        <el-dialog v-if="DialogVisible" :visible.sync="DialogVisible" title="预览" class="yulan-dialog_001" width="90%" fullscreen>
            <div class="yulan-dialog_tools">
                <el-button  icon="el-icon-download" @click="download(downurl)" >下载</el-button>
            </div>
            <div class="yulan-dialog_001-wrap">
                <div class="yulan-dialog_iframe_wrap">
                    <iframe :src="iframeurl" style="" class="yulan-dialog_iframe"></iframe>
                </div>
            </div>


        </el-dialog>

        <el-dialog v-if="DialogVisibleExcel" :visible.sync="DialogVisibleExcel" title="预览" class="yulan-dialog_002" width="90%" fullscreen>
            <div class="yulan-dialog_tools">
                <el-button  icon="el-icon-download" @click="download(downurl)" >下载</el-button>
            </div>
            <div class="yulan-dialog_001-wrap">
                <div class="yulan-dialog_iframe_wrap">
                    <iframe :src="iframeurl" style="" class="yulan-dialog_iframe"></iframe>
                </div>
            </div>


        </el-dialog>
    </div>
</template>

<script>
import Constant from '../utils/constant'
import moment from 'moment'

export default {
    name: "FilesDataTable",
    data() {
        return {
            DialogVisible:false,
            DialogVisibleExcel:false,
            iframeurl:'',
            downurl:'',
            columns: [
                {
                    name: '附件名称',
                    field: 'name'
                },
                {
                    name: '附件大小',
                    field: 'size',
                    formatter: function (r, c, v) {
                        return ((Number(v) || 0) / 1024).toFixed(2) + ' KB'
                    }
                },
                // {
                //   name: '上传时间',
                //   field: 'createdDate',
                //   formatter: function (r,c,v) {
                //     return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
                //   }
                // },
            ],
            optColumn: [
                {
                    name: '操作',
                    opts: [
                        {
                            label: '预览附件',
                            class: 'el-icon-view',
                            clickHandler: (index, row) => {
                                this.DialogVisible = true
                                try {
                                    let fileUri = row.fileId.indexOf('static') !== -1 ?
                                        window.location.origin + Constant.SERVER_BASE_URL+ row.fileId:
                                        window.location.origin + Constant.SERVER_BASE_URL + '/preview/' + row.fileId + '/!/' + row.name+'#toolbar=0'
                                    this.iframeurl = fileUri
                                    let  fileUri2 = row.fileId.indexOf('static') !== -1 ?
                                        Constant.SERVER_BASE_URL+ row.fileId:
                                        Constant.SERVER_BASE_URL + '/files/' + row.fileId + '/!/' + row.name
                                    this.downurl = fileUri2
                                } catch (e) {

                                }
                            },
                            conditions: row=> row.name.indexOf('xlsx')===-1&&row.name.indexOf('xls')===-1
                        },
                        {
                            label: '预览附件',
                            class: 'el-icon-view',
                            clickHandler: (index, row) => {
                                this.DialogVisibleExcel = true
                                try {
                                    let fileUri = row.fileId.indexOf('static') !== -1 ?
                                        window.location.origin + Constant.SERVER_BASE_URL+ row.fileId:
                                        window.location.origin + Constant.SERVER_BASE_URL + '/preview/' + row.fileId + '/!/' + row.name
                                    this.iframeurl = fileUri
                                    let  fileUri2 = row.fileId.indexOf('static') !== -1 ?
                                        Constant.SERVER_BASE_URL+ row.fileId:
                                        Constant.SERVER_BASE_URL + '/files/' + row.fileId + '/!/' + row.name
                                    this.downurl = fileUri2
                                } catch (e) {

                                }
                            },
                            conditions: row=> row.name.indexOf('xlsx')>-1||row.name.indexOf('xls')>-1
                        },

                        {
                            label: '下载附件',
                            class: 'el-icon-download',
                            clickHandler: (index, row) => {
                                try {
                                    let fileUri = row.fileId.indexOf('static') !== -1 ?
                                        Constant.SERVER_BASE_URL+ row.fileId:
                                        Constant.SERVER_BASE_URL + '/files/' + row.fileId + '/!/' + row.name

                                    window.open(fileUri)
                                } catch (e) {

                                }
                            }
                        },
                        {
                            label: '删除附件',
                            class: 'el-icon-remove',
                            clickHandler: 'removeItem',
                            conditions: this.editable
                        }
                    ]
                }
            ]
        }
    },
    props: {
        files: {
            type: Array,
            default: () => {
                return []
            }
        },
        editable: {
            type: Boolean,
            default: false
        },
        additionalColumns: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        fileList: {
            get() {
                return this.files.map(file => {
                    Object.keys(file).map(item => {
                        file[item.replace('f__', '')] = file[item]
                    })
                    return file
                }).filter(item => item.fileId)
            },
            set(newVal) {
                this.$emit('update:files', newVal)
            }
        },
        tableData: {
            get() {
                return {
                    data: this.fileList,
                    count: this.fileList.length
                }
            }
        },
        tableColumns: {
            get() {
                return [{
                    type: 'index',
                }].concat(this.columns).concat(this.additionalColumns).concat(this.optColumn)
            }
        }
    },
    methods: {
        download:function(url){
            window.open(url)
        },
        removeItem: function (index, row) {
            this.$confirm(`确定移除文件： ${row.name}？`)
                .then(() => {
                    this.fileList.splice(index, 1)
                    this.fileList = this.fileList
                })
                .catch(() => {
                })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FilesDataTable.vue